import { computed, onBeforeUnmount, onMounted, watch } from 'vue'
import { getSizeCategory, setupThemeSize } from '@/__core__/style/theme'

export function useThemeSizes(containerRef, containerWidth) {
  const sizeCategory = computed(() => getSizeCategory(containerWidth.value))

  const unwatchContainerWidth = watch(containerWidth, async () => setupThemeSize(containerRef, sizeCategory.value))

  onMounted(() => setupThemeSize(containerRef, sizeCategory.value))

  onBeforeUnmount(unwatchContainerWidth)
}
